import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { API, auth, errMsg, PageHead } from './finance/shared';
import Icon from '../../components/dashboard/DashboardIcons';

export default function IntegrationsPage() {
  const navigate = useNavigate();
  const { user } = useOutletContext() || {};
  const [interested, setInterested] = useState(false);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    axios.get(`${API}/integrations/cartat-interest/status`, auth())
      .then((res) => setInterested(Boolean(res.data?.registered)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const registerInterest = async () => {
    if (busy || interested) return;
    setBusy(true);
    setErr('');
    try {
      await axios.post(`${API}/integrations/cartat-interest`, {}, auth());
      setInterested(true);
      setConfirmMsg('تم تسجيل اهتمامك — لم يتم ربط أي حساب أو احتساب أي رسوم.');
      setTimeout(() => setConfirmMsg(''), 5000);
    } catch (e) {
      setErr(errMsg(e, 'تعذّر تسجيل الاهتمام، حاول لاحقاً'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-5xl space-y-4" dir="rtl" data-testid="integrations-page">
      <PageHead title="التطبيقات والتكاملات" desc="ربط منشأتك بأدوات وخدمات إضافية" />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {/* بطاقة 1: رسائل واتساب الجاهزة — متاحة الآن */}
        <div className="flex flex-col rounded-2xl border border-slate-200 bg-white p-5" data-testid="integration-card-whatsapp">
          <div className="flex items-start justify-between gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-600">
              <Icon name="whatsapp" className="h-5 w-5" />
            </div>
            <span className="rounded-full bg-teal-100 px-3 py-1 text-xs font-bold text-teal-700" data-testid="integration-badge-whatsapp">متاحة الآن</span>
          </div>
          <h3 className="mt-3 text-base font-bold text-slate-800">رسائل واتساب الجاهزة</h3>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">
            أرسل رسائل جاهزة عبر واتساب للاعبين وأولياء الأمور والموظفين مباشرة من داخل تسيار — مشمولة ضمن باقتك الحالية دون أي رسوم إضافية.
          </p>
          <button
            type="button"
            onClick={() => navigate('/communication')}
            className="mt-4 rounded-lg bg-[#16233b] px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#1d2f4d]"
            data-testid="integration-whatsapp-goto-btn"
          >
            الانتقال لصفحة التواصل
          </button>
        </div>

        {/* بطاقة 2: واتساب للأعمال عبر كارتات — قريباً */}
        <div className="flex flex-col rounded-2xl border border-slate-200 bg-white p-5" data-testid="integration-card-cartat">
          <div className="flex items-start justify-between gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
              <Icon name="bolt" className="h-5 w-5" />
            </div>
            <span className="rounded-full bg-orange-100 px-3 py-1 text-xs font-bold text-orange-700" data-testid="integration-badge-cartat">قريبًا</span>
          </div>
          <h3 className="mt-3 text-base font-bold text-slate-800">واتساب للأعمال عبر كارتات</h3>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">
            اربط رقم واتساب الخاص بمنشأتك باتصال مستقل، وأرسل الرسائل الرسمية من تسيار وتابع حالات الرسائل بسهولة.
          </p>

          {confirmMsg && (
            <div className="mt-3 rounded-lg border border-teal-200 bg-teal-50 px-3 py-2 text-sm text-teal-700" data-testid="integration-cartat-confirm-message">
              {confirmMsg}
            </div>
          )}
          {err && (
            <div className="mt-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="integration-cartat-error">
              {err}
            </div>
          )}

          <button
            type="button"
            onClick={registerInterest}
            disabled={busy || loading || interested}
            className={`mt-4 rounded-lg px-4 py-2.5 text-sm font-bold transition-colors disabled:cursor-not-allowed ${
              interested
                ? 'border border-teal-300 bg-teal-50 text-teal-700'
                : 'bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-60'
            }`}
            data-testid="integration-cartat-notify-btn"
          >
            {loading ? 'جارٍ التحميل...' : interested ? '✓ تم تسجيل اهتمامك' : busy ? 'جارٍ التسجيل...' : 'أعلمني عند الإطلاق'}
          </button>
        </div>
      </div>
    </div>
  );
}
